import { CreditCard } from "lucide-react";

function Material({ currentLang, searchQuery }) {
  const btnText = { en: "Purchase", gr: "Αγορά", it: "Acquista" };
  const badgeText = { en: "PDF Document", gr: "Ψηφιακό Έγγραφο", it: "Documento PDF" };
  const noResultsText = { en: "No matching materials found.", gr: "Δεν βρέθηκε εκπαιδευτικό υλικό.", it: "Nessun materiale trovato." };

  const items = [
    { title: "History B.4. (1st Grade of Junior High)", desc: "The religion and art of the Minoans", link: "https://eduki.com/gr/1711784" },
    { title: "History B.6. (1st Grade of Junior High)", desc: "Mycenaean religion and art", link: "https://eduki.com/gr/1711791" },
    { title: "History B.2. (1st Grade of Junior High)", desc: "Chapter 2: The Bronze Age", link: "https://eduki.com/gr/1711796" },
    { title: "History B.5. (1st Grade of Junior High)", desc: "The Mycenaean civilization", link: "https://eduki.com/gr/1711787" },
    { title: "History B.3. (1st Grade of Junior High)", desc: "The Minoan civilization", link: "https://eduki.com/gr/1711297" },
    { title: "History D.1. (1st Grade of Junior High)", desc: "The colonial expansion", link: "https://eduki.com/gr/1727545" },
    { title: "History B.2. (1st Grade of Junior High)", desc: "The Cycladic civilization", link: "https://eduki.com/gr/1711285" }
  ];

  // Compares user typed query text against BOTH description text and full PDF string title keys
  const filteredItems = items.filter(item => 
    item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.desc.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div>
      {filteredItems.length === 0 ? (
        <div className="text-center py-5 text-muted">
          <p>{noResultsText[currentLang]}</p>
        </div>
      ) : (
        <div className="row g-4">
          {filteredItems.map((item, idx) => (
            <div key={idx} className="col-lg-3 col-md-6 col-sm-12">
              <div className="card material-card h-100">
                <div className="card-header custCard">
                  <span className="badge bg-light text-success border border-success-subtle mb-2 d-inline-block" style={{ fontSize: '10px' }}>
                    {badgeText[currentLang]}
                  </span>
                  <div style={{ fontWeight: 600, fontSize: '14px', color: '#1a2421' }}>{item.title}</div>
                </div>
                <div className="card-body custHeight text-muted" style={{ fontSize: '14px', fontStyle: 'italic' }}>
                  {item.desc}
                </div>
                <div className="card-footer bg-transparent border-0 px-3 pb-3">
                  <a href={item.link} className="purchaseBtn" target="_blank" rel="noreferrer">
                    {btnText[currentLang]} <CreditCard size={15} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Material;